export default "/assets/images/mama-room1.png?713104a82988aa7fa0b0620b4b7ed48c";